import { Component, EventEmitter, Input, NgZone, Output, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
//import { formatDate } from '@angular/common';
import { GridDataResult, GridComponent } from '@progress/kendo-angular-grid';
import { State } from '@progress/kendo-data-query';
//import { take } from 'rxjs/operators';
import { Subscription } from 'rxjs';
//import { ConfirmDialog } from '../modals/confirm-dialog.component';
import { ApplicationControlService } from '../../services/applicationcontrol.service';
import { CRMService } from '../../services/crm.service';
import { DataService } from '../../services/data.service';
import { EmployeeService } from '../../services/employees.service';
import { NotificationService } from '../../services/notification.service';
import { OrderService } from '../../services/order.service';
import { RecordLockService } from '../../services/recordlock.service';
import { UtilService } from '../../services/util.service';
import {
    AddOrderStop
    //, CheckCall
    , City
    , CommodityType
    , Customer
    , CustomerLookup
    , DataCollection
    , Employee
    , FreightDetail
    , OrderEventSchedule
    , OrderStop
    , QuoteOrderLine
    , ReferenceNumber
    , SearchCustomer
    , SearchOrderEventType
    , SearchOrderStop
    , SearchOrderStopCommodity
    , UnitOfMeasure
} from '../../models/models';

@Component({
    selector: 'order-stop-form',
    templateUrl: './order-stop-form.component.html',
    standalone: false
})
export class OrderStopForm implements OnInit {
    @Input() orderStopID: number = 0;
    @Input() newStop: AddOrderStop = {} as AddOrderStop;
    @Input() isAddStop: boolean = false;
    @Input() pageType: string = "";
    @Output() onRefresh = new EventEmitter<any>();
    @Output() onCancel = new EventEmitter<any>();

    @ViewChild(GridComponent, { static: false }) public stopsGrid!: GridComponent;

    //private subAddOrderStop: Subscription | undefined;
    //private subEditOrderStop: Subscription | undefined;
    private subUnitofMeasures: Subscription | undefined;
    private subAllEmployees: Subscription | undefined;
    //private subOrderStops: Subscription | undefined;
    //private subQuoteOrderLines: Subscription | undefined;

    public orderNumber: string = "";
    public quoteOrderID: number = 0;
    public quoteOrderLineID: number = 0;
    //public orderStopID: number = 0;
    //public isAddStop: boolean = false;
    public isEditStop: boolean = false;
    public isAccountManager: boolean = false;
    public isExportHub: boolean = false;

    public orderStopCustomer: SearchCustomer = {} as SearchCustomer;
    public stopCityID: number = 0;
    public isAddOrderStopCustomer: boolean = false;
    public isEditOrderStopCustomer: boolean = false;
    public editedOrderStop: OrderStop = {} as OrderStop;
    public originalOrderStop: OrderStop = {} as OrderStop;
    public orderStopEarliestDate: Date = new Date();
    public orderStopLatestDate: Date = new Date();
    public orderStopArrivalDate: Date = new Date();
    public orderStopDepartDate: Date = new Date();
    private minStopDate?: Date;
    private maxStopDate?: Date;
    public isOrderStopEarliestValid: boolean = true;
    public isOrderStopLatestValid: boolean = true;
    public isOrderStopArrivalValid: boolean = true;
    public isOrderStopDepartValid: boolean = true;

    public allEmployees: Employee[] = [];
    public orderEventSchedule: OrderEventSchedule[] = [];
    public orderStops: OrderStop[] = [];
    public currentOrderStops: OrderStop[] = [];
    //public orderStop: OrderStop | undefined;
    public searchOrderStop: SearchOrderStop = {} as SearchOrderStop;
    public searchOrderStops: SearchOrderStop[] = [];
    //public orderStopSaveList: OrderStop[] = [];
    public quoteOrderLines: QuoteOrderLine[] = [];
    private freightDetail: FreightDetail = {} as FreightDetail;
    public searchOrderEventTypes: SearchOrderEventType[] = [];
    public dropStopEventTypes: SearchOrderEventType[] = [];
    public pickStopEventTypes: SearchOrderEventType[] = [];
    public filteredStopEventTypes: SearchOrderEventType[] = [];
    public orderStopEventTypes: SearchOrderEventType[] = [];
    public commodityTypes: CommodityType[] = [];
    public referenceNumbers: ReferenceNumber[] = [];
    //public trackingCheckCall: CheckCall | undefined;
    public pieceUnits: UnitOfMeasure[] = [];
    public weightUnits: UnitOfMeasure[] = [];
    public stopView: GridDataResult = { data: [], total: 0 };
    public stopState: State = { skip: 0, take: 10, sort: [{ dir: 'asc', field: 'stopSequence' }] };
    public isStopValid: boolean = true;
    public isLoading: boolean = false;
    public orderStopEventTypeID: number = 0;
    public commodities: string = "";
    public commodityTypeID: number = 0;
    //public newReferenceNumber: string = '';
    //public newReferenceType: string = '';

    public recordLockAction: string = "";
    public recordLockSource: string = "";

    public customerFormGroup: UntypedFormGroup = new UntypedFormGroup({
        stopCityCtrl: new UntypedFormControl(''),
        orderStopCustomerCtrl: new UntypedFormControl('')
    });

    //private lastStopID: number = 0;
    //private editedOrderStop: OrderStop | undefined;
    //private editedStopRowIndex: number | undefined;

    constructor(private applicationControlService: ApplicationControlService, private crmService: CRMService,
        private dataService: DataService, private employeeService: EmployeeService,
        private notificationService: NotificationService, private orderService: OrderService,
        private ngZone: NgZone, private recordLockService: RecordLockService, private utilService: UtilService) {
        this.orderService.getUnitOfMeasures().subscribe(result => {
            this.pieceUnits = result.filter(u => u.piecesUnitInd == true);
            this.weightUnits = result.filter(u => u.weightUnitInd == true);
        });
        var name = "GetUnitOfMeasures";
        if (this.subUnitofMeasures) {
            this.subUnitofMeasures.unsubscribe();
        }
        var data = this.dataService.get(name);
        if (data) {
            this.pieceUnits = data.resultCollection.filter(u => u.piecesUnitInd == true);
            this.weightUnits = data.resultCollection.filter(u => u.weightUnitInd == true);
            //console.log("unitOfMeasures", this.pieceUnits, this.weightUnits);
        }
        else {
            this.subUnitofMeasures = this.dataService.currentDataCollection.subscribe(result => {
                if (result.name == name) {
                    this.pieceUnits = result.resultCollection.filter(u => u.piecesUnitInd == true);
                    this.weightUnits = result.resultCollection.filter(u => u.weightUnitInd == true);
                    //console.log("unitOfMeasures", this.pieceUnits, this.weightUnits);
                }
            });
        }
    }

    ngOnInit() {
        this.applicationControlService.getApplicationControlsByAppName("ExportHub").subscribe(result => {
            if (result.length > 0) {
                var appValue = result[0].appSettingValue;
                if (appValue == "1") {
                    this.isExportHub = true;
                }
                else {
                    this.isExportHub = false;
                }
            }
        });

        this.isAccountManager = this.getIsAccountManager();

        //this.getQuoteOrderLines();
        //this.getSearchOrderStops();
        this.getCommodityTypes();
        //this.getReferenceNumbers();
        //this.getEmployeeInfo();

        this.getSearchOrderEventTypes();

        if (this.newStop.stop) {
            this.orderService.getSearchOrderStopByID(this.orderStopID).subscribe(result => {
                this.isAddStop = true;
                this.searchOrderStop = this.newStop.searchStop;
                this.quoteOrderID = this.searchOrderStop.quoteOrderID;
                this.orderNumber = this.searchOrderStop.orderNumber;
                this.quoteOrderLineID = this.searchOrderStop.quoteOrderLineID;
                this.getAddOrderStop(this.newStop);
                //this.getOrderStops();
            });
        }
        else {
            this.orderService.getSearchOrderStopByID(this.orderStopID).subscribe(result => {
                this.searchOrderStop = result.resultCollection[0];
                this.isEditStop = true;
                this.quoteOrderID = this.searchOrderStop.quoteOrderID;
                this.orderNumber = this.searchOrderStop.orderNumber;
                this.quoteOrderLineID = this.searchOrderStop.quoteOrderLineID;
                this.getOrderStops();
            });
        }

        this.initRecordLock();
    }

    private getIsAccountManager() {
        var employeeRoles = localStorage.getItem('EmployeeRoles');

        //console.log(employeeRoles);
        if (employeeRoles != null && employeeRoles.length > 0) {
            if (employeeRoles.indexOf('Account Manager') > -1) return true;
        }

        return false;
    }

    private getEmployeeInfo() {
        var name = "GetAllEmployees";
        if (this.subAllEmployees) {
            this.subAllEmployees.unsubscribe();
        }
        var data = this.dataService.get(name);
        if (data) {
            this.allEmployees = data.resultCollection;
            //console.log("allEmployees", this.allEmployees);
        }
        else {
            this.subAllEmployees = this.dataService.currentDataCollection.subscribe(result => {
                if (result.name == name) {
                    this.allEmployees = result.resultCollection;
                    //console.log("allEmployees", this.allEmployees);
                }
            });
        }
    }

    private getCommodityTypes() {
        this.isLoading = true;
        this.orderService.getAllCommodityTypes().subscribe(result => {
            this.isLoading = false;
            this.commodityTypes = result.resultCollection;
            this.commodityTypes = this.commodityTypes.sort((left, right): number => {
                if (left.name < right.name) return -1;
                if (left.name > right.name) return 1;
                return 0;
            });
        });
    }

    private getSearchOrderEventTypes() {
        this.isLoading = true;
        this.orderService.getGetAllSearchOrderEventType().subscribe(result => {
            this.isLoading = false;
            this.searchOrderEventTypes = result;

            if (this.pageType == "orderentry") {
                this.orderStopEventTypes = this.searchOrderEventTypes.filter(c =>
                    c.eventTypeName == "Order Stop"
                    && (
                        c.code == "LUL"
                        || c.code == "LLD"
                        || c.code == "NBS"
                        || c.code == "NBCST"
                    )
                );
            }
            else {
                this.orderStopEventTypes = this.searchOrderEventTypes.filter(c =>
                    c.eventTypeName == "Order Stop"
                );
            }

            this.filteredStopEventTypes = Object.assign([], this.orderStopEventTypes);

            var dropStopTypes = this.searchOrderEventTypes.filter(c =>
                c.eventTypeName == "Order Stop" && c.reportDescription == "Delivery" && c.code != "DLT");
            dropStopTypes = dropStopTypes.sort((left, right): number => {
                if (left.code < right.code) return -1;
                if (left.code > right.code) return 1;
                return 0;
            });

            this.dropStopEventTypes = dropStopTypes;
            var pickStopTypes = this.searchOrderEventTypes.filter(c =>
                c.eventTypeName == "Order Stop" && c.reportDescription == "Pickup" && c.code != "HLT");
            pickStopTypes = pickStopTypes.sort((left, right): number => {
                if (left.code < right.code) return -1;
                if (left.code > right.code) return 1;
                return 0;
            });
            this.pickStopEventTypes = pickStopTypes;
        });
    }

    public isEventTypeDisabled() {
        var isDisabled: boolean = false;
        if (this.editedOrderStop.orderStopId > 0) {
            var loadStops: OrderStop[] = this.orderStops.filter(t => t.quoteOrderLineId == this.editedOrderStop.quoteOrderLineId);
            if (this.pageType != "orderentry") {
                isDisabled = true;
            }
            else if (this.editedOrderStop.stopSequence == loadStops[0].stopSequence) {
                isDisabled = true;
            }
            else if (this.editedOrderStop.stopSequence == loadStops[loadStops.length - 1].stopSequence) {
                isDisabled = true;
            }
            else if (this.editedOrderStop.arrivedInd == true || this.editedOrderStop.departedInd == true) {
                isDisabled = true;
            }
            //console.log("isEventTypeDisabled", isDisabled, this.editedOrderStop.stopSequence, loadStops[0].stopSequence, loadStops[loadStops.length - 1].stopSequence);
        }
        if (this.searchOrderStop.invoiceStatus == 'Prepared') {
            isDisabled = true;
        }
        return isDisabled;
    }

    public checkPieces() {
        if (this.editedOrderStop.pieces > 1000000) {
            this.editedOrderStop.pieces = 1000000;
        }
        if (this.editedOrderStop.pieces < 0) {
            this.editedOrderStop.pieces = 0;
        }
    }

    public checkWeight() {
        if (this.editedOrderStop.weight > 1000000) {
            this.editedOrderStop.weight = 1000000;
        }
        if (this.editedOrderStop.weight < 0) {
            this.editedOrderStop.weight = 0;
        }
    }

    private getAddOrderStop(addStop: AddOrderStop) {
        //console.log("getAddOrderStop", addStop, this.newOrderStop, this.quoteOrderLine);
        if (addStop.stop != null) {
            this.refreshAddOrderStop();
            var stop: OrderStop = addStop.stop;
            //this.getAddSplitOrderStops(addStop.stop.quoteOrderLineId, addStop.stop.orderStopId, addStop.stopPlace);

            this.orderService.getOrderStopsByLineId(stop.quoteOrderLineId).subscribe(result => {
                this.currentOrderStops = result.resultCollection;
                this.isLoading = false;
                if (result.resultCollection.length > 0) {
                    var stops: OrderStop[] = result.resultCollection;
                    //var nextStop = stops.find(t => t.stopSequence = stop.stopSequence + 1);
                    var stopsAfter: OrderStop[] = stops.filter(t => t.stopSequence > stop.stopSequence);
                    var prevStop: OrderStop = {} as OrderStop;
                    var nextStop: OrderStop = {} as OrderStop;
                    if (addStop.stopPlace == "before") {
                        nextStop = addStop.stop;
                    }
                    else if (addStop.stopPlace == "after" && stopsAfter.length > 0) {
                        prevStop = addStop.stop;
                        nextStop = stopsAfter.reduce(function (prev, current) {
                            return (prev.stopSequence < current.stopSequence) ? prev : current
                        });
                    }
                    if (addStop.stopPlace == "before" && stop.stopSequence == 1) {
                        this.filteredStopEventTypes = Object.assign([], this.pickStopEventTypes);
                    }
                    else if (addStop.stopPlace == "after" && nextStop.stopSequence == undefined) {
                        this.filteredStopEventTypes = Object.assign([], this.dropStopEventTypes);
                    }
                    else {
                        this.filteredStopEventTypes = Object.assign([], this.orderStopEventTypes);
                    }
                    //console.log("filteredStopEventTypes", addStop.stopPlace, stops.length, stop.stopSequence, this.filteredStopEventTypes);
                    //console.log("addOrderStop:nextStop", nextStop);
                    if (addStop.stopPlace == "before" && stop.stopSequence == 1) {
                        this.minStopDate = undefined;
                    }
                    else {
                        this.minStopDate = new Date(stop.earliestDate);
                    }
                    if (nextStop) {
                        this.maxStopDate = new Date(nextStop.earliestDate);
                    }
                    else {
                        this.maxStopDate = undefined;
                    }

                    this.orderStopEarliestDate = new Date(stop.earliestDate);
                    this.orderStopLatestDate = new Date(stop.latestDate);

                    if (nextStop) {
                        console.log("getAddOrderStop", "earliest", this.orderStopEarliestDate, "latest", this.orderStopLatestDate, "arrival", this.orderStopArrivalDate, "depart", this.orderStopDepartDate, this.searchOrderStop, nextStop, stop);
                        //this.dateChanged("orderStop");
                        this.dateChanged("orderStop");
                        this.getNewOrderStop(stop);
                    }
                    else {
                        this.notificationService.showError("Error loading next stop", "ERROR: Add Stop");
                    }
                }
                else {
                    this.notificationService.showError("Error loading stops", "ERROR: Add Stop");
                }
            });
        }
        else {
            this.notificationService.showError("Error adding stop", "ERROR: Add Stop");
        }
    }

    private refreshAddOrderStop() {
        this.editedOrderStop = {} as OrderStop;
        this.originalOrderStop = {} as OrderStop;
        this.isAddOrderStopCustomer = false;
        this.isEditOrderStopCustomer = false;
        this.orderStopCustomer = {} as SearchCustomer;
        this.customerFormGroup.controls["orderStopCustomerCtrl"].setValue("");
        //this.getCustomer(0, "orderStopCustomer");
        this.orderStopEarliestDate = new Date();
        this.orderStopLatestDate = new Date();
        this.isOrderStopEarliestValid = true;
        this.isOrderStopLatestValid = true;
        this.isOrderStopArrivalValid = true;
        this.isOrderStopDepartValid = true;
    }

    private getNewOrderStop(stop: OrderStop) {
        this.editedOrderStop = Object.assign({}, stop);
        var employeeID = parseInt(localStorage.getItem('EmployeeId')!);

        this.editedOrderStop.orderStopId = 0;
        this.editedOrderStop.createdByEmployeeId = employeeID;
        this.editedOrderStop.stopSequence = 0;
        this.editedOrderStop.stopNumber = 0;
        this.editedOrderStop.earliestDate = new Date(stop.earliestDate);
        this.editedOrderStop.latestDate = new Date(stop.latestDate);
        //this.editedOrderStop.arrivalDate = this.utilService.addMinutes(new Date(stop.arrivalDate), 1);
        //this.editedOrderStop.departDate = this.utilService.addMinutes(new Date(stop.departDate), 1);
        //this.editedOrderStop.city = {} as City;
        this.editedOrderStop.customer = {} as Customer;
        this.editedOrderStop.commodity = {} as SearchOrderStopCommodity;
        this.editedOrderStop.comment = "";

        //console.log("getNewOrderStop", this.minStopDate, this.maxStopDate, stop, this.editedOrderStop);
    }

    private setStops() {
        this.isLoading = true;
        if (this.quoteOrderID > 0) {
            this.orderService.getSearchOrderStopsByQuoteOrderID(this.quoteOrderID).subscribe(result => {
                this.isLoading = false;
                var datCol: DataCollection = {
                    name: "GetOrderStopsByQuoteOrderID-" + this.quoteOrderID,
                    resultCollection: result.resultCollection
                }
                this.dataService.set(datCol);

                //for (var i = 0; i < this.quoteOrderLines.length; i++) {
                //    this.updateERPByQuoteOrderLineID(this.quoteOrderLines[i].quoteOrderLineID);
                //}

                this.cancelEdit();
            });
        }
        else {
            this.orderService.getStopsByOrderNumber(this.orderNumber).subscribe(result => {
                this.isLoading = false;
                var datCol: DataCollection = {
                    name: "GetOrderStopsByOrderNumber-" + this.orderNumber,
                    resultCollection: result.resultCollection
                }
                this.dataService.set(datCol);

                //for (var i = 0; i < this.quoteOrderLines.length; i++) {
                //    this.updateERPByQuoteOrderLineID(this.quoteOrderLines[i].quoteOrderLineID);
                //}

                this.cancelEdit();
            });
        }
    }

    private getOrderStops() {
        this.isLoading = true;
        if (this.quoteOrderID > 0) {
            this.orderService.getStopsByQuoteOrderID(this.quoteOrderID).subscribe(result => {
                this.isLoading = false;
                this.orderStops = result.resultCollection;
                if (this.orderStopID > 0) {
                    this.getOrderStopsPostProcess();
                }
            });
        }
        else {
            this.orderService.getStopsByOrderNumber(this.orderNumber).subscribe(result => {
                this.isLoading = false;
                this.orderStops = result.resultCollection;
                if (this.orderStopID > 0) {
                    this.getOrderStopsPostProcess();
                }
            });
        }
    }

    private getOrderStopsPostProcess() {
        var employeeID = parseInt(localStorage.getItem('EmployeeId')!);

        this.orderStops = this.orderStops.sort((left, right): number => {
            if (left.stopSequence < right.stopSequence) return -1;
            if (left.stopSequence > right.stopSequence) return 1;
            return 0;
        });

        this.setupStopData();

        //this.editedOrderStop = this.orderStops.find(s => s.orderStopId == this.orderStopID) || {} as OrderStop;
        var thisStop: OrderStop = this.orderStops.find(s => s.orderStopId == this.orderStopID) || {} as OrderStop;
        this.editedOrderStop = Object.assign({}, thisStop);
        this.originalOrderStop = Object.assign({}, thisStop);
        this.getCustomer(this.editedOrderStop.customerId, "orderStop");
        //console.log("getOrderStopsPostProcess", this.orderStopID, this.editedOrderStop.eventCode, this.editedOrderStop, this.orderStopEventTypes);
        this.orderStopEventTypeID = this.searchOrderEventTypes.find(t => t.code == this.editedOrderStop.eventCode)!.orderEventTypeID;
        if (this.isEditStop) {
            if (this.isEventTypeDisabled()) {
                //this.filteredStopEventTypes = Object.assign([], this.searchOrderEventTypes);
                this.filteredStopEventTypes = this.searchOrderEventTypes.filter(t => t.orderEventTypeID == this.orderStopEventTypeID);
                console.log("filteredStopEventTypes", this.filteredStopEventTypes);
            }
            else if (this.editedOrderStop.stopSequence == 1) {
                this.filteredStopEventTypes = Object.assign([], this.pickStopEventTypes);
            }
            else if (this.editedOrderStop.stopSequence == this.orderStops[this.orderStops.length - 1].stopSequence) {
                this.filteredStopEventTypes = Object.assign([], this.dropStopEventTypes);
            }
            else {
                this.filteredStopEventTypes = Object.assign([], this.orderStopEventTypes);
            }
        }
        //this.orderStopEventTypeChange(this.orderStopEventTypeID);
        this.orderStopEarliestDate = new Date(this.editedOrderStop.earliestDate);
        this.orderStopLatestDate = new Date(this.editedOrderStop.latestDate);
        this.orderStopArrivalDate = new Date(this.editedOrderStop.arrivalDate);
        this.orderStopDepartDate = new Date(this.editedOrderStop.departDate);
        //this.editedOrderStop.city = {} as City;
        this.editedOrderStop.customer = {} as Customer;
        this.editedOrderStop.commodity = {} as SearchOrderStopCommodity;
        this.editedOrderStop.lastModifiedByEmployeeId = employeeID;

        this.getFreightDetail();
        this.setMinMaxDates();

        console.log("getOrderStopsPostProcess", this.orderStopID, this.editedOrderStop);
    }

    private setupStopData() {
        this.orderStops.forEach(s => {
            s.earliestDate = new Date(s.earliestDate);
            s.latestDate = new Date(s.latestDate);
            s.arrivalDate = new Date(s.arrivalDate);
            s.departDate = new Date(s.departDate);
        });

        if (this.searchOrderStop.invoiceStatus == 'PPD') {
            this.isStopValid = false;
        }
    }

    private getFreightDetail() {
        this.orderService.getFreightDetailsByOrderStopID(this.editedOrderStop.orderStopId).subscribe(result => {
            if (result.resultCollection.length > 0) {
                this.freightDetail = result.resultCollection[0];
            }
            else {
                this.freightDetail.freightDetailId = 0;
                this.freightDetail.orderStopId = this.editedOrderStop.orderStopId;
                this.freightDetail.sequence = 0;
            }
        })
    }

    private getOrderEventSchedule(quoteOrderLineId: number) {
        this.orderService.getOrderEventScheduleByQuoteOrderLineId(quoteOrderLineId).subscribe(result => {
            this.orderEventSchedule = result.resultCollection;

            this.orderEventSchedule = this.orderEventSchedule.sort((left, right): number => {
                if (left.orderEventSequence < right.orderEventSequence) return -1;
                if (left.orderEventSequence > right.orderEventSequence) return 1;
                return 0;
            });

            this.orderEventSchedule.forEach(s => {
                var eventType = this.searchOrderEventTypes.find(t => t.orderEventTypeID == s.orderEventTypeID)!;
                s.orderEventDate = new Date(s.orderEventDate);
                s.completedDate = new Date(s.completedDate);
                s.code = eventType.code;
                s.orderStop = this.getOrderStop(s.orderStopID)!;
                // This line must come after s.isNonStopOrderEvent
                //s.isRefreshNeeded = this.checkRefreshNeeded(s);
            });
        });

    }

    private getOrderStop(orderStopId: number) {
        return this.orderStops.find(s => s.orderStopId == orderStopId);
    }

    public cancelEdit() {
        //this.orderStopSaveList.length = 0;
        //this.stopCloseEditor(sender, rowIndex);
        this.isStopValid = true;
        this.isAddStop = false;
        this.isEditStop = false;
        this.editedOrderStop = {} as OrderStop;
        this.originalOrderStop = {} as OrderStop;
        this.newStop = {} as AddOrderStop;
        this.editedOrderStop.orderStopId = 0;
        this.orderStops.length = 0;
        this.orderStops.push(this.editedOrderStop);

        var addDataCol: DataCollection = {
            name: "AddOrderStop-AddOrderStop",
            resultCollection: []
        }
        this.dataService.set(addDataCol);

        var editDataCol: DataCollection = {
            name: "EditOrderStop-SearchOrderStop",
            resultCollection: this.orderStops
        }
        this.dataService.set(editDataCol);

        this.recordLockAction = "";

        this.onCancel.emit();
    }

    private resetOrderStop(stop: OrderStop) {
        if (!stop) return;

        const originalStop = this.orderStops.find(s => s.orderStopId == stop.orderStopId)!;

        Object.assign(originalStop, stop);
    }

    public saveOrderStop() {
        this.recordLockAction = "saveOrderStop";
        this.recordLockService.checkHasRecordLock("QuoteOrder", this.quoteOrderID, this.recordLockSource);
    }

    private allowSaveOrderStop() {
        this.adjustActualStopDates();
        //var isActualChange: boolean = false;

        if (this.validateFields("stop")) {
            this.isLoading = true;
            if (this.orderStopCustomer.customerID >= 0) {
                this.editedOrderStop.cityId = this.orderStopCustomer.cityID;
            }
            this.editedOrderStop.earliestDate = this.utilService.getDateAsUTC(this.orderStopEarliestDate);
            this.editedOrderStop.latestDate = this.utilService.getDateAsUTC(this.orderStopLatestDate);
            if (this.isAddStop) {
                this.editedOrderStop.arrivalDate = this.utilService.getDateAsUTC(this.orderStopArrivalDate);
                this.editedOrderStop.departDate = this.utilService.getDateAsUTC(this.orderStopDepartDate);
                //if (this.searchOrderStop.carrierID > 0) {
                //    this.editedOrderStop.arrivalDate = this.utilService.getDateAsUTC(this.orderStopArrivalDate);
                //    this.editedOrderStop.departDate = this.utilService.getDateAsUTC(this.orderStopDepartDate);
                //}
                //else {
                //    this.editedOrderStop.arrivalDate = this.utilService.getDateAsUTC(this.orderStopEarliestDate);
                //    this.editedOrderStop.departDate = this.utilService.getDateAsUTC(this.orderStopLatestDate);
                //}
                console.log("saveOrderStop", "earliest", this.orderStopEarliestDate, "latest", this.orderStopLatestDate, "arrival", this.orderStopArrivalDate, "depart", this.orderStopDepartDate, this.searchOrderStop);
            }
            else {
                this.editedOrderStop.arrivalDate = this.utilService.getDateAsUTC(this.orderStopArrivalDate);
                this.editedOrderStop.departDate = this.utilService.getDateAsUTC(this.orderStopDepartDate);
            }
            //this.notificationService.showInfo("This is not implemented yet", "INFO: Not Implemented");
            if (this.editedOrderStop.orderStopId > 0) {
                this.utilService.setAuditNotes(this.utilService.getPageTypeName(this.pageType) + ": Stop Form Update Stop");
                this.orderService.saveOrderStop(this.editedOrderStop, this.pageType).subscribe(result => {
                    this.isLoading = false;
                    if (result.resultCollection.length > 0) {
                        //this.saveReferenceNumber(this.editedOrderStop.orderStopId, this.editedOrderStop.stopNumber);
                        this.saveFreightDetail();
                        var stop: OrderStop = result.resultCollection[0];
                        this.notificationService.showSuccess("Stop Saved: " + stop.eventCode, "SUCCESS: Save Stop");
                        //console.log("saveOrderStop", this.orderStopCustomer, this.editedOrderStop, result);
                        this.refreshOrderEventSchedule(this.editedOrderStop);
                        //this.refreshData();
                    }
                    else {
                        this.notificationService.showError("Error saving Stop", "ERROR: Save Stop");
                    }
                });
            }
            else {
                this.utilService.setAuditNotes(this.utilService.getPageTypeName(this.pageType) + ": Stop Form Add Stop");
                this.orderService.saveOrderStop(this.editedOrderStop, this.pageType).subscribe(result => {
                    this.isLoading = false;
                    if (result.resultCollection.length > 0) {
                        var stop: OrderStop = result.resultCollection[0];
                        //this.isAddStop = false;
                        this.notificationService.showSuccess("Added New Stop " + stop.eventCode, "SUCCESS: Add Stop");
                        var freightDetail: FreightDetail = Object.assign({}, this.freightDetail);
                        this.isLoading = true;
                        this.orderService.getFreightDetailsByOrderStopID(stop.orderStopId).subscribe(result => {
                            this.isLoading = false;
                            if (result.resultCollection.length > 0) {
                                freightDetail = result.resultCollection[0];
                                freightDetail.commodityTypeID = this.freightDetail.commodityTypeID;
                                freightDetail.commodityCode = this.freightDetail.commodityCode;
                                freightDetail.commodityDescription = this.freightDetail.commodityDescription;
                                freightDetail.commodityNotes = this.freightDetail.commodityNotes;
                                this.freightDetail = Object.assign(freightDetail);
                                this.saveFreightDetail();
                            }
                            this.refreshData();
                        });
                        //this.getQuoteOrder(this.quoteOrderID);
                        //this.refreshAllData();
                        //this.refreshData("loads");
                        //this.refreshData("stops");
                        console.log("saveAddOrderStop", result);
                        //this.refreshData();
                    }
                    else {
                        this.notificationService.showError("Error saving new Stop", "ERROR: Save Stop");
                    }
                });
            }
        }
    }

    public saveFreightDetail() {
        this.isLoading = true;
        this.freightDetail.pieces = this.editedOrderStop.pieces;
        this.freightDetail.piecesUnit = this.editedOrderStop.piecesUnit;
        this.freightDetail.piecesUnitOfMeasureId = this.editedOrderStop.piecesUnitOfMeasureId;
        this.freightDetail.weight = this.editedOrderStop.weight;
        this.freightDetail.weightUnit = this.editedOrderStop.weightUnit;
        this.freightDetail.weightUnitOfMeasureId = this.editedOrderStop.weightUnitOfMeasureId;

        this.orderService.saveFreightDetail(this.freightDetail).subscribe(result => {
            this.isLoading = false;
            if (result.resultCollection.length > 0) {
                this.freightDetail = result.resultCollection[0];
            }
        });
    }

    public refreshData() {
        //this.getQuoteOrderLine(-1);
        //this.refreshLoadSplit();
        //this.editedOrderStop = {} as OrderStop;
        this.isAddStop = false;
        this.isEditStop = false;
        this.minStopDate = undefined;
        this.maxStopDate = undefined;
        this.cancelEdit();
        this.onRefresh.emit();
        //this.stopsRefreshDate = new Date();
    }

    private validateFields(formType: string) {
        var isValid: boolean = true;
        var msg: string = "";
        if (this.editedOrderStop.customerId == null || this.editedOrderStop.customerId == 0) {
            isValid = false;
            msg = "Customer Required";
        }
        if (this.editedOrderStop.eventCode == null || this.editedOrderStop.eventCode == "") {
            isValid = false;
            msg = "Event Code Required";
        }
        if (!this.isOrderStopEarliestValid || !this.isOrderStopLatestValid) {
            isValid = false;
            msg = "Earliest and/or Latest date invalid";
        }
        if (!this.isOrderStopArrivalValid || !this.isOrderStopDepartValid) {
            isValid = false;
            msg = "Arrival and/or Depart date invalid";
        }
        if (!isValid) {
            this.notificationService.showWarning("Please correct required fields. " + msg, "WARNING: Fields Required");
        }
        return isValid;
    }

    private adjustActualStopDates() {
        if (this.isAddStop) {
            var addStop = this.newStop;
            var stop = addStop.stop;
            var stopsAfter: OrderStop[] = this.currentOrderStops.filter(t => t.stopSequence > stop.stopSequence);
            var prevStop: OrderStop = {} as OrderStop;
            var nextStop: OrderStop = {} as OrderStop;
            if (addStop.stopPlace == "before") {
                nextStop = addStop.stop;
            }
            else if (addStop.stopPlace == "after" && stopsAfter.length > 0) {
                prevStop = addStop.stop;
                nextStop = stopsAfter.reduce(function (prev, current) {
                    return (prev.stopSequence < current.stopSequence) ? prev : current
                });
            }
            var minArrivalDate = new Date(stop.earliestDate);
            var maxDepartDate = new Date(stop.earliestDate);
            var thisEarliest = new Date(this.orderStopEarliestDate);
            if (addStop.stopPlace == "before") {
                // Added before first stop
                maxDepartDate = new Date(stop.arrivalDate);
                var stopDepart = new Date(stop.departDate);
                if (maxDepartDate > stopDepart) {
                    // Earliest date entered is OK
                    this.orderStopArrivalDate = new Date(this.orderStopEarliestDate);
                    this.orderStopDepartDate = this.utilService.addMinutes(new Date(this.orderStopArrivalDate), 1);
                }
                else {
                    // New depart date would occur after next arrival date, so set it to 1min before
                    this.orderStopArrivalDate = this.utilService.addMinutes(new Date(stop.arrivalDate), -2);
                    this.orderStopDepartDate = this.utilService.addMinutes(new Date(stop.arrivalDate), -1);
                }
            }
            else {
                // Added after this stop
                if (stopsAfter.length == 0) {
                    // Added after last stop
                    minArrivalDate = new Date(stop.departDate);
                    if (minArrivalDate < thisEarliest) {
                        // Earliest date entered is OK
                        this.orderStopArrivalDate = new Date(this.orderStopEarliestDate);
                    }
                    else {
                        // New arrival date would occur before last depart date, so set it to 1min after
                        this.orderStopArrivalDate = this.utilService.addMinutes(new Date(stop.departDate), 1);
                    }
                    this.orderStopDepartDate = this.utilService.addMinutes(new Date(this.orderStopArrivalDate), 1);
                }
                else {
                    // Added between first and last stop
                    minArrivalDate = new Date(prevStop.departDate);
                    maxDepartDate = new Date(nextStop.arrivalDate);
                    //console.log("adjustActualStopDates", "minArrivalDate", minArrivalDate, "maxDepartDate", maxDepartDate, "earliest", this.orderStopEarliestDate, "arrival", this.orderStopArrivalDate);
                    if (minArrivalDate < thisEarliest && thisEarliest < maxDepartDate) {
                        // Earliest date entered is OK
                        this.orderStopArrivalDate = thisEarliest;
                        //console.log("adjustActualStopDates: between OK", "minArrivalDate", minArrivalDate, "maxDepartDate", maxDepartDate, "earliest", thisEarliest, "arrival", this.orderStopArrivalDate);
                    }
                    else {
                        // New arrival date would occur before previous depart date or after next arrival date, so set it to 1min after previous depart date
                        this.orderStopArrivalDate = this.utilService.addMinutes(new Date(stop.departDate), 1);
                        //console.log("adjustActualStopDates: between adjust", "minArrivalDate", minArrivalDate, "maxDepartDate", maxDepartDate, "earliest", this.orderStopEarliestDate, "arrival", this.orderStopArrivalDate);
                    }
                    this.orderStopDepartDate = this.utilService.addMinutes(new Date(this.orderStopArrivalDate), 1);
                }
            }
            console.log("adjustActualStopDates:min/max", "minArrivalDate", minArrivalDate, "maxDepartDate", maxDepartDate);
        }
        else {
            var prevStop = this.orderStops.find(t => t.stopSequence == this.editedOrderStop.stopSequence - 1) as OrderStop;
            var nextStop = this.orderStops.find(t => t.stopSequence == this.editedOrderStop.stopSequence + 1) as OrderStop;
            //console.log("adjustActualStopDates", prevStop, nextStop);
            var minArrivalDate: Date;
            var maxDepartDate: Date;
            var editedEarliest = new Date(this.editedOrderStop.earliestDate);
            var editedDepart = new Date(this.editedOrderStop.departDate);
            if (!prevStop) {
                // First stop
                maxDepartDate = new Date(nextStop.arrivalDate);
                if (maxDepartDate > editedDepart) {
                    // Earliest date entered is OK
                    if (this.editedOrderStop.arrivedInd != true) {
                        this.editedOrderStop.arrivalDate = new Date(this.editedOrderStop.earliestDate);
                    }
                    if (this.editedOrderStop.departedInd != true) {
                        this.editedOrderStop.departDate = this.utilService.addMinutes(new Date(this.editedOrderStop.arrivalDate), 1);
                    }
                }
                else {
                    // New depart date would occur after next arrival date, so set it to 1min before
                    if (this.editedOrderStop.arrivedInd != true) {
                        this.editedOrderStop.arrivalDate = this.utilService.addMinutes(new Date(nextStop.arrivalDate), -2);
                    }
                    if (this.editedOrderStop.departedInd != true) {
                        this.editedOrderStop.departDate = this.utilService.addMinutes(new Date(nextStop.arrivalDate), -1);
                    }
                }
            }
            else if (!nextStop) {
                // Last stop
                minArrivalDate = new Date(prevStop.departDate);
                if (this.editedOrderStop.arrivedInd != true) {
                    if (minArrivalDate < editedEarliest) {
                        // Earliest date entered is OK
                        this.editedOrderStop.arrivalDate = new Date(this.editedOrderStop.earliestDate);
                    }
                    else {
                        // New arrival date would occur before last depart date, so set it to 1min after
                        this.editedOrderStop.arrivalDate = this.utilService.addMinutes(new Date(prevStop.departDate), 1);
                    }
                }
                if (this.editedOrderStop.departedInd != true) {
                    this.editedOrderStop.departDate = this.utilService.addMinutes(new Date(this.editedOrderStop.arrivalDate), 1);
                }
            }
            else {
                // Middle stop
                minArrivalDate = new Date(prevStop.departDate);
                maxDepartDate = new Date(nextStop.arrivalDate);
                if (this.editedOrderStop.arrivedInd != true) {
                    if (minArrivalDate < editedEarliest && editedEarliest < nextStop.arrivalDate) {
                        // Earliest date entered is OK
                        this.editedOrderStop.arrivalDate = new Date(this.editedOrderStop.earliestDate);
                    }
                    else {
                        // New arrival date would occur before previous depart date or after next arrival date, so set it to 1min after previous depart date
                        this.editedOrderStop.arrivalDate = this.utilService.addMinutes(new Date(prevStop.departDate), 1);
                    }
                }
                if (this.editedOrderStop.departedInd != true) {
                    this.editedOrderStop.departDate = this.utilService.addMinutes(new Date(this.editedOrderStop.arrivalDate), 1);
                }
            }
        }
    }

    public orderStopEventTypeChange(evt: any) {
        var val: number = evt.target.value;
        var dropTxt: string = this.dropStopEventTypes.find(t => t.orderEventTypeID == val) != null ? this.dropStopEventTypes.find(t => t.orderEventTypeID == val)!.code : "";
        var pickTxt: string = this.pickStopEventTypes.find(t => t.orderEventTypeID == val) != null ? this.pickStopEventTypes.find(t => t.orderEventTypeID == val)!.code : "";
        var stopTxt: string = this.orderStopEventTypes.find(t => t.orderEventTypeID == val) != null ? this.orderStopEventTypes.find(t => t.orderEventTypeID == val)!.code : "";
        var id: number = 0;
        this.editedOrderStop.eventCode = stopTxt;
        this.editedOrderStop.stopType = "";
        //console.log("orderStopEventTypeChange", val, dropTxt, pickTxt, this.editedOrderStop, evt);
    }

    public onCityChange(evt: any, ctrl: string) {
        var selectedCity = this.customerFormGroup.controls[ctrl].value as City;
        if (ctrl == "stopCityCtrl") {
            if (!isNaN(evt) && evt != null && evt > 0) {
                //this.pickCity = evt.option.value;
                this.stopCityID = evt;
            }
            else if (selectedCity.cityID) {
                this.stopCityID = selectedCity.cityID;
            }
            this.editedOrderStop.cityId = this.stopCityID;
            this.editedOrderStop.customerId = -1;
        }
        console.log("onCityChange", evt, ctrl, this.editedOrderStop.cityId, this.stopCityID, selectedCity);
    }

    public onCustomerChange(evt: any, ctrl: string) {
        var selectedCustomer = this.customerFormGroup.controls[ctrl].value as CustomerLookup;

        if (ctrl == "orderStopCustomerCtrl") {
            this.orderStopCustomer = {} as SearchCustomer;
            this.isAddOrderStopCustomer = false;
            this.isEditOrderStopCustomer = false;
            if (!isNaN(evt) && evt != null) {
                this.editedOrderStop.customerId = evt;
            }
            else {
                this.editedOrderStop.customerId = selectedCustomer.customerID;
            }
            this.getCustomer(this.editedOrderStop.customerId, "orderStop");
        }
    }

    private getCustomer(customerID: number, customerType: string) {
        this.crmService.getSearchCustomerByID(customerID).subscribe(result => {
            var cust: SearchCustomer = result.resultCollection[0];
            if (customerType == "orderStop") {
                this.orderStopCustomer = Object.assign({}, cust);
            }
        });
    }

    public addCustomer() {
        this.isAddOrderStopCustomer = true;
    }

    public editCustomer() {
        this.isEditOrderStopCustomer = true;
    }

    public refreshCustomers(customerID: number, customerType: string) {
        if (customerType == "orderStop") {
            this.isAddOrderStopCustomer = false;
            this.isEditOrderStopCustomer = false;
        }
        if (customerID) {
            //this.onCustomerChange(customerID, "OrderStoporderStopCustomerCtrl");
            this.editedOrderStop.customerId = customerID;
            this.getCustomer(customerID, customerType);
        }
        console.log("refreshCustomers", customerID, customerType);
    }

    private setMinMaxDates() {
        var prevStop: OrderStop | undefined;
        var nextStop: OrderStop | undefined;
        var idx: number = -1;

        idx = this.orderStops.findIndex(t => t.stopSequence == this.editedOrderStop.stopSequence - 1);
        if (idx >= 0) {
            prevStop = this.orderStops[idx];
            this.minStopDate = prevStop.earliestDate;
        }
        idx = this.orderStops.findIndex(t => t.stopSequence == this.editedOrderStop.stopSequence + 1);
        if (idx >= 0) {
            nextStop = this.orderStops[idx];
            this.maxStopDate = nextStop.earliestDate;
        }
    }

    public dateChanged(field: string) {
        //this.utilService.getDateAsUTC(
        //console.log("dateChanged:local", source, field, this.shipperEarliestDate, this.shipperLatestDate, this.consigneeEarliestDate, this.consigneeLatestDate);
        //console.log("dateChanged:UTC", source, field, this.utilService.getDateAsUTC(this.shipperEarliestDate), this.utilService.getDateAsUTC(this.shipperLatestDate), this.utilService.getDateAsUTC(this.consigneeEarliestDate), this.utilService.getDateAsUTC(this.consigneeLatestDate));
        this.isOrderStopEarliestValid = true;
        this.isOrderStopLatestValid = true;

        if (this.orderStopEarliestDate > this.orderStopLatestDate) {
            if (field == "earliest") {
                var latestDate = new Date(this.orderStopEarliestDate);
                latestDate = this.utilService.addMinutes(latestDate, 1);
                this.orderStopLatestDate = new Date(latestDate);
            }
            else {
                this.isOrderStopEarliestValid = false;
                this.isOrderStopLatestValid = false;
            }
        }
        if (this.minStopDate && this.orderStopEarliestDate <= this.minStopDate
            || this.maxStopDate && this.orderStopEarliestDate >= this.maxStopDate) {
            this.isOrderStopEarliestValid = false;
        }

        if (this.editedOrderStop.departedInd == true) {
            this.isOrderStopEarliestValid = true;
            this.isOrderStopLatestValid = true;
        }

        if (this.isAddStop && field == "earliest") {
            this.orderStopArrivalDate = new Date(this.orderStopEarliestDate);
            this.orderStopDepartDate = this.utilService.addMinutes(new Date(this.orderStopEarliestDate), 1);
        }

        if (field == "arrival") {
            this.stopArrivalDateChanged(false);
        }
        if (field == "depart") {
            this.stopDepartDateChanged(false);
        }
    }

    //private updateERPByQuoteOrderLineID(id: number) {
    //    if (this.isExportHub != true) {
    //        this.notificationService.showInfo("Updating TMW Stops ...", "TMW Update");
    //        this.orderService.updateERPOrderStopsByQuoteOrderLineId(id, "TMW").subscribe(result => {
    //            var ok = result;
    //            if (result.message != "OK") {
    //                this.notificationService.showError("Error updating TMW: " + result.message, "ERROR: TMW Update");
    //            }
    //            else {
    //                this.notificationService.showInfo("TMW Update Complete", "TMW Update");
    //            }
    //        });
    //    }
    //}

    private refreshOrderEventSchedule(stop: OrderStop) {
        // Send lineId and date
        var saveStop: OrderStop = Object.assign({}, stop);
        //saveStop.earliestDate = this.utilService.getDateAsUTC(saveStop.earliestDate);
        //saveStop.latestDate = this.utilService.getDateAsUTC(saveStop.latestDate);
        //saveStop.arrivalDate = this.utilService.getDateAsUTC(saveStop.arrivalDate);
        //saveStop.departDate = this.utilService.getDateAsUTC(saveStop.departDate);
        this.isLoading = true;
        if (this.pageType == "orderentry") {
            this.orderService.updateOrderEventScheduleByPlannedDate(saveStop).subscribe(result => {
                this.isLoading = false;
                var ok = result
                if (stop.quoteOrderLineId > 0) {
                    this.orderService.exportQuoteOrder(stop.quoteOrderLineId).subscribe(exportedOrder => {
                        console.log("exportQuoteOrder:result", exportedOrder);
                    });
                }
                this.notificationService.showSuccess("Event Schedule Updated", "SUCCESS: Update Event Schedule");
                //console.log("updateOrderEventScheduleByPlannedDate", stop, result);
                this.setStops();
                this.refreshData();
                //this.onRefresh.emit();
            });
        }
        else {
            this.orderService.updateOrderEventScheduleByActualDate(saveStop).subscribe(result => {
                this.isLoading = false;
                var ok = result;
                if (stop.quoteOrderLineId > 0) {
                    this.orderService.exportQuoteOrder(stop.quoteOrderLineId).subscribe(exportedOrder => {
                        console.log("exportQuoteOrder:result", exportedOrder);
                    });
                }
                this.notificationService.showSuccess("Event Schedule Updated", "SUCCESS: Update Event Schedule");
                this.setStops();
                this.refreshData();
                //this.onRefresh.emit();
            });
        }
    }

    public getMaxPlannedDateByStop(stop: OrderStop): Date | undefined {
        var nextStop = this.orderStops.find(s => s.stopSequence == (stop.stopSequence + 1));

        if (nextStop != null) return nextStop.earliestDate;
    }

    public getMinPlannedDateByStop(stop: OrderStop): Date | undefined {
        var previousStop = this.orderStops.find(s => s.stopSequence == (stop.stopSequence - 1));

        if (previousStop != null) return previousStop.earliestDate;
    }

    public getMaxActualDateByStop(stop: OrderStop): Date | undefined {
        var nextStop = this.orderStops.find(s => s.stopSequence == (stop.stopSequence + 1));

        if (nextStop != null) return nextStop.arrivalDate;
    }

    public getMinActualDateByStop(stop: OrderStop): Date | undefined {
        var previousStop = this.orderStops.find(s => s.stopSequence == (stop.stopSequence - 1));

        if (previousStop != null) return previousStop.departDate;
    }

    public stopArrivalDateChanged(isDateChanged: boolean) {
        if (this.orderStopArrivalDate == null) return;

        var diffDays = this.utilService.getDateDiffDays(this.originalOrderStop.arrivalDate, this.orderStopArrivalDate);
        var diffHours = this.utilService.getDateDiffHours(this.originalOrderStop.arrivalDate, this.orderStopArrivalDate);
        //console.log(diffDays);
        if (diffDays >= 1 && diffHours <= 24) {
            if (isDateChanged) {
                this.orderStopArrivalDate.setHours(0, 0, 0, 0);
            }
            if (this.orderStopArrivalDate > this.editedOrderStop.departDate) {
                this.orderStopDepartDate = new Date(this.orderStopArrivalDate);
                this.orderStopDepartDate.setHours(this.orderStopDepartDate.getHours() + 1);
            }
        }

        this.stopActualDateChanged();
    }

    public stopDepartDateChanged(isDateChanged: boolean) {
        if (this.orderStopDepartDate == null) return;

        var diffDays = this.utilService.getDateDiffDays(this.originalOrderStop.departDate, this.orderStopDepartDate);
        var diffHours = this.utilService.getDateDiffHours(this.originalOrderStop.departDate, this.orderStopDepartDate);
        //console.log(diffDays);
        if (diffDays >= 1 && diffHours <= 24) {
            if (isDateChanged) {
                this.orderStopDepartDate.setHours(0, 0, 0, 0);
            }
        }

        this.stopActualDateChanged();
    }

    public stopActualDateChanged() {
        this.isStopValid = true;
        this.isOrderStopArrivalValid = true;
        this.isOrderStopDepartValid = true;

        if (this.searchOrderStop.invoiceStatus == "PPD") {
            this.isStopValid = false;
            return;
        }

        var min = this.getMinActualDateByStop(this.editedOrderStop);
        //var max = this.getMaxPlannedDateByStop(stop);

        if (min != null && this.orderStopArrivalDate <= min) {
            this.isStopValid = false;
            this.isOrderStopArrivalValid = false;
        }

        if (this.orderStopDepartDate <= this.orderStopArrivalDate) {
            this.isStopValid = false;
            this.isOrderStopArrivalValid = false;
            this.isOrderStopDepartValid = false;
        }
        //else {
        //    this.isStopValid = true;
        //}
        console.log("stopActualDateChanged", this.isStopValid, "min", min, "arrivalDate", this.orderStopArrivalDate, "departDate", this.orderStopDepartDate);
    }

    private initRecordLock() {
        this.recordLockAction = "";
        this.recordLockSource = "Loads Grid";
        if (this.pageType == "orderentry") {
            //this.recordLockSource = "Order Entry: Loads Grid";
            this.recordLockSource = "Order Entry";
        }
        else if (this.pageType == "carriersales" || this.pageType == "procurement") {
            this.recordLockSource = "Procurement";
        }
        else if (this.pageType == "tracking") {
            this.recordLockSource = "Tracking Dashboard";
        }
        else if (this.pageType == "crossborder") {
            this.recordLockSource = "Cross Border";
        }

        this.recordLockService.hasRecordLockObserver.subscribe(result => {
            //console.log("order-form:handleRecordLock:isContinueRecorLock", this.recordLockService.isContinueRecordLock);
            if (this.recordLockService.hasRecordLock) {
                if (this.recordLockAction == "saveOrderStop") {
                    this.allowSaveOrderStop();
                }
                this.recordLockAction = "";
            }
        });
    }
}
